<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start" v-if="$route.path !== '/'">
        <ion-back-button defaultHref="/" @click="$router.go(-1)"></ion-back-button>
      </ion-buttons>

      <ion-buttons slot="primary">
        <ion-menu-button
          auto-hide="false"
          @click="openMenu()"
        ></ion-menu-button>
      </ion-buttons>

      <ion-title class="app-title"><div class="header-box"><img alt="OphthoRuler logo" class="header-logo"/> <span class="header-text">OphthoRuler</span></div></ion-title>
    </ion-toolbar>
  </ion-header>
</template>

<script lang='js'>
import { IonToolbar, IonTitle, menuController, IonBackButton,
    IonButtons,
    IonMenuButton,
    IonHeader } from "@ionic/vue";

import { helpCircle, moon, moonOutline } from "ionicons/icons";
import { defineComponent } from "vue";

export default defineComponent({
  name: "HeaderBar",
  components: {
    IonToolbar,
    IonTitle,
    IonBackButton,
    IonButtons,
    IonMenuButton,
    IonHeader
  },
  setup() {
    return {
      helpCircle,
      moon,
      moonOutline
    };
  },
   data() {
    return {
      darkModeIcon: moonOutline
    };
  },
  watch: {
    '$route': function() {
      // console.log(this.$route)
      // Set 'dark' class and darkModeIcon = true if darkMode === 'on'
      const darkMode = localStorage.getItem("darkMode");
      // console.log(darkMode);
      // let darkModeIcon = false
      if (darkMode === "on") {
        // console.log('dark mode')
        // document.body.classList.add('dark');
        this.darkModeIcon = moon;
        // console.log(this.darkModeIcon);
      } else {
        // console.log('light mode')
        this.darkModeIcon = moonOutline;
        // document.body.classList.remove('dark');
      }
    },
  },
  mounted() {
    // Set 'dark' class and darkModeIcon = true if darkMode === 'on'
      const darkMode = localStorage.getItem("darkMode");
      // console.log(darkMode);
      // let darkModeIcon = false
      if (darkMode === "on") {
        // console.log('dark mode')
        document.body.classList.add('dark');
        this.darkModeIcon = moon;
        // console.log(this.darkModeIcon);
      } else {
        // console.log('light mode')
        this.darkModeIcon = moonOutline;
        document.body.classList.remove('dark');
      }
  },
  methods: {
    gotoPage(pageName) {
      this.$router.push({
        name: pageName,
      });
    },
      openMenu() {
      menuController.enable(true, "side-menu");
      menuController.open("side-menu");
    },
    // toggle dark class and set darkMode = 'on' or 'off' in localstorage
    toggleDarkMode() {
      document.body.classList.toggle("dark");
      if (localStorage.getItem("darkMode") === "on") {
        localStorage.setItem("darkMode", "off");
        this.darkModeIcon = moonOutline;
      } else {
        localStorage.setItem("darkMode", "on");
        this.darkModeIcon = moon;
      }
    },
  },
});
</script>

<style scoped>
.app-title {
  font-size: 1.2rem;
}

.header-logo {
    content: url('data:image/svg+xml;base64,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');
    display: block;
    height: 30px;
    padding-top: 2px;
    padding-right: 10px;
    margin-left: auto;
  }
  .header-text {
    margin-right: auto;
  }
  .header-box {
    display: flex;
    align-items: center;
  }
ion-title.md {
        width: 100%;
        position: absolute;
        left: 0;
        height: 0;
        text-align: center;
}
</style>